import { createContext, useContext } from "react";
import type { UseDarkModeReturn } from "./useDarkMode";

type DarkModeContextValue = {
    theme: UseDarkModeReturn[0];
    toggleMode: UseDarkModeReturn[1];
    componentMounted: UseDarkModeReturn[2];
};

export const DarkModeContext = createContext<DarkModeContextValue | null>(null);

export const useDarkModeContext = (): DarkModeContextValue => {
    const context = useContext(DarkModeContext);
    if (!context) {
        throw new Error("useDarkModeContext must be used with DarkModeContextProvider");
    }
    return context;
};
